import React from 'react'

function Technology() {
  return (
    <div className="talent_profile_detail">
                                <h5>Technology Analyst</h5>
                                <div className="exp_detail_wrapper">
                                    <div className="exp_content">
                                        <div>
                                            <h6>Company's name :</h6>                                            
                                            <span>Interactive Brokers</span>
                                        </div>
                                        <div>
                                            <h6>Company's URL :</h6>
                                            <span>www</span>
                                        </div>
                                        <div>
                                            <h6>Company's country :</h6>
                                            <span>--</span>
                                        </div>
                                        <div>
                                            <h6>Company's city :</h6>
                                            <span>--</span>
                                        </div>
                                        <div>
                                            <h6>From :</h6>
                                            <span>--</span>
                                        </div>
                                        <div>
                                            <h6>To :</h6>
                                            <span>--</span>
                                        </div>
                                    </div>
                                    <div>
                                        <h6>Work summary :</h6>
                                        <ul className="mt-3">
                                            <li>Worked on the project to move existing clients from the old back-offices
                                                 (GTS-Global Trade System) to the new and more technologically advanced back-offices
                                                  (TPS-Trade Processing System) from scratch using Java and its Frameworks. Doing so
                                                   decreased the manpower required for processing information by 30%.</li>
                                           <li>Chaired tasks involving creation and enhancement of over 100 reports using JasperSoft tool for
                                             6 clients.</li>
                                            <li>Held the position of responsibility for regular code deployments to QA/UAT servers using CI/CD tools like Jules/Jenkins.</li>
                                            <li>Developed over 20 screens for Trade Channel Front End (TCFE) in order to comply with the ADA(American Disability Act) using React JS.</li>
                                        </ul>
                                    </div>
                                    <div className="mt-4">
                                        <h6>Accomplishments :</h6>
                                        <ul className="mt-3">
                                            <li>--</li>                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
  )
}

export default Technology